/* eslint-disable camelcase */

import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaCt0X0 } from '~/endpoints/ApiTaCt0X0'

interface ActionParamsATRRequest {
  evalType: ApiTaCt0X0.Post.EvalType
  stimid: string
  adjust: number
  rhythm_adjust: number
  accent_adjust: number
  snd: string
}

interface Scores {
  score: string
  rhythm_score: string
  accent_score: string
}

interface ATRStatusState {
  status: string
  data: Scores
}

const getEmptyATRStatusState = (): ATRStatusState => ({
  status: '',
  data: {
    score: '',
    rhythm_score: '',
    accent_score: '',
  },
})

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/ATR',
})
export default class ATR extends VuexModule {
  // State
  private atrStatus_ = getEmptyATRStatusState()

  // Getters
  get atrStatus(): ATRStatusState {
    return this.atrStatus_
  }

  // Mutations
  @Mutation
  updateATRStatus(value: ATRStatusState) {
    this.atrStatus_ = value
  }

  // Actions

  @Action
  clear() {
    this.context.commit('updateATRStatus', getEmptyATRStatusState())
  }

  @Action
  async requestATR(param: ActionParamsATRRequest) {
    logger.trace('in: requestATR')

    // 前回の結果をリセットする
    this.context.commit('updateATRStatus', getEmptyATRStatusState())

    // API: API_TA_CT_0X0
    const api = new ApiTaCt0X0.Api()
    const result = await api.post<ATRStatusState | null>(
      {
        body: {
          evalType: param.evalType,
          stimid: param.stimid,
          adjust: param.adjust,
          rhythm_adjust: param.rhythm_adjust,
          accent_adjust: param.accent_adjust,
          snd: param.snd,
        },
      },
      (data, _) => {
        return {
          status: data.status,
          data: data.data,
        }
      },
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )

    if (result === null) {
      return
    }

    this.context.commit('updateATRStatus', result)
  }
}
